import { combineReducers } from "redux";
import loginReducer from "./loginReducer";
import poolReducer from "./poolReducer";
import poolsReducer from "./poolsReducer";
import poolTokenReducer from "./poolTokenReducer";
import securityTokenReducer from "./securityTokenReducer";
import tokenReducer from "./tokenReducer";
import transactionsReducer from "./transactionsReducer";
import balanceReducer from "./balanceReducer";
import assetsReducer from "./assetsReducer";
import basicAccountReducer from "./basicAccountReducer";
import detailAccountReducer from "./detailAccountReducer";
import submitDetailAccountReducer from "./submitDetailAccountReducer"
import issuedTokensReducer from "./issuedTokensReducer";
import submitIssuerInfoReducer from "./submitIssuerInfoReducer";
import assetInfoReducer from "./assetInfoReducer";
import permissionsReducer from "./permissionsReducer";
import kycAccountReducer from "./kycAccountReducer";
import createAccountReducer from "./createAccountReducer";
import emailVerificationReducer from "./emailVerificationReducer";
import issuedAssetsReducer from "./issuedAssetsReducer";
import createTokenReducer from "./createTokenReducer";
import submitTokenReducer from "./submitTokenReducer";
import createAssetReducer from "./createAssetReducer";
import submitAssetReducer from "./submitAssetReducer";
import uploadMediaReducer from "./uploadMediaReducer";
import getAllMediaTypesReducer from "./getAllMediaTypesReducer";
import submitPrimarySaleReducer from "./submitPrimarySaleReducer";
import issuerInfoReducer from "./issuerInfoReducer";
import issuerTransactionsReducer from "./issuerTransactionsReducer"
import removeMediaReducer from "./removeMediaReducer";

// TBR doc, imgs, vid, typesbycat


const rootReducer = combineReducers({
    login: loginReducer,
    pool: poolReducer,
    pools: poolsReducer,
    token: tokenReducer,
    poolToken: poolTokenReducer,
    securityToken: securityTokenReducer,
    assetInfo: assetInfoReducer,
    transactions: transactionsReducer,
    balance: balanceReducer,
    assets: assetsReducer,
    basicAccount: basicAccountReducer,
    detailAccount: detailAccountReducer,
    submitDetailAccount: submitDetailAccountReducer,
    issuedTokens : issuedTokensReducer,
    issuedAssets: issuedAssetsReducer,
    kycAccount: kycAccountReducer,
    permissions: permissionsReducer,
    createAccount: createAccountReducer,
    emailVerification: emailVerificationReducer,
    createAsset: createAssetReducer,
    submitAsset: submitAssetReducer,
    createToken: createTokenReducer,
    submitToken: submitTokenReducer,
    uploadMedia: uploadMediaReducer,
    removeMedia: removeMediaReducer,
    mediaTypes: getAllMediaTypesReducer,
    //primarySalesReducer: primarySalesReducer,
    submitPrimarySale: submitPrimarySaleReducer,
    issuerInfo: issuerInfoReducer,
    submitIssuerInfo: submitIssuerInfoReducer,
    issuerTransactions: issuerTransactionsReducer
})

export default rootReducer
export type State = ReturnType<typeof rootReducer>